/* const grApi = import.meta.env.VITE_GREENROOM_API;
        if (!grApi) {
          console.error("Greenroom API not found");
          return;
        }

        const url = `${grApi}/v2/greenroom/events/get-session-by-uuid/${sessionUuid}` */

import type { Meeting } from '@/types/greenroom/meeting.types';
import { Get } from '../helpers';

export function GetGreenroomMeetingData(sessionUuid: string, token: string): Promise<Meeting | null> {
  const url = `${import.meta.env.VITE_GREENROOM_API}/v2/greenroom/events/get-session-by-uuid/${sessionUuid}`;
  return Get({
    path: url,
    headers: {
      'bl-token': token,
      'bl-global-resource': 'false',
    },
    useCache: true,
    cacheTtl: 60,
  });
}
